import { FiCheck, FiTrash2, FiX } from 'react-icons/fi';
import React from 'react';
import { getTheme } from '@Thread-Magic/jasmine';
import TextButton from 'src/components/TextButton';
import { useTheme } from 'styled-components';
import { TruncatedText } from 'src/components/common/Typography';

const formatTimeSaved = timeSaved => {
  const hours = Math.floor(timeSaved / 60);
  const minutes = timeSaved % 60;

  let formattedTime = '';
  if (hours > 0) {
    formattedTime += `${hours} hour${hours > 1 ? 's' : ''}`;
  }
  if (minutes > 0) {
    if (hours > 0) {
      formattedTime += ', ';
    }
    formattedTime += `${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  return formattedTime || '0 minutes';
};

const EditColumnButton = props => {
  return (
    <TextButton className="show-on-row-hover" size={16} {...props}>
      Edit
    </TextButton>
  );
};

const DeleteColumnButton = props => {
  const theme = useTheme();
  return (
    <TextButton className="show-on-row-hover" size={16} {...props}>
      <FiTrash2 color={theme.colors.danger.main} />
    </TextButton>
  );
};

export const getColumns = ({ onEditClick, onDeleteClick }) => [
  {
    key: 'name',
    title: 'Name',
    isSort: true
  },
  {
    key: 'description',
    title: 'Description',
    component: row => <TruncatedText>{row.description}</TruncatedText>,
    isSort: true
  },
  {
    key: 'time_saved',
    title: 'Time saved',
    component: row => formatTimeSaved(row.time_saved),
    isSort: true
  },
  {
    key: 'visibility_scope',
    title: 'Visibility',
    isSort: true
  },
  {
    key: 'is_active',
    title: 'Active',
    isSort: true,
    compact: true,
    component: row =>
      row.is_active ? (
        <FiCheck color={getTheme().colors.brand.light.base} size={16} />
      ) : (
        <FiX color={getTheme().colors.danger.dark} size={16} />
      )
  },
  {
    key: 'action-edit',
    title: '',
    isSort: false,
    compact: true,
    component: row => <EditColumnButton onClick={e => onEditClick(row, e)} />
  },
  {
    key: 'action-delete',
    title: '',
    isSort: false,
    compact: true,
    component: row => <DeleteColumnButton onClick={e => onDeleteClick(row, e)} />
  }
];

export const argumentTypes = [
  { label: 'Textfield', value: 'text' },
  {
    label: 'Number',
    value: 'number'
  },
  {
    label: 'Date',
    value: 'date'
  },
  {
    label: 'Email address',
    value: 'email'
  },
  {
    label: 'Yes/No',
    value: 'boolean'
  },
  {
    label: 'Multiple choice',
    value: 'multiple'
  }
];
